import {Component, inject, OnInit} from '@angular/core';
import {finalize, takeUntil} from 'rxjs';
import {ExportDataSettingBase} from '@shared/components/export-data/export-data-setting.base';
import {AppFormAddComponent} from '@shared/components/app-form';
import {ConversationApiService} from '@shared/services/api/conversation/conversation-api.service';
import type {IProgressPaginator} from '@shared/services/global/excel.service';
import {uriConsts} from '@shared/constants';

@Component({
  standalone: false,
  selector: 'app-google-sheet-export',
  templateUrl: './google-sheet-export.component.html',
  providers: [AppFormAddComponent],
})
export class GoogleSheetExportComponent extends ExportDataSettingBase implements OnInit {
  protected readonly exportType = 'googleSheets';
  googleAccountEmail = '';
  googleAccountLoadError = false;
  private isLoadingGoogleAccount = false;
  private conversationApiService = inject(ConversationApiService);

  override ngOnInit() {
    super.ngOnInit();
    this.loadDepsDataGoogleSheet();
  }

  protected onProgress(progress: IProgressPaginator) {
    this.progressState.isFinal = progress.isDone === true;
  }

  onExportData() {
    if (this.progressState.isExportSubmit) return;
    if (!this.isLoadingTabGGSheet || this.googleAccountLoadError || !this.googleAccountEmail) {
      return;
    }
    const stat$ = {...this.state};
    stat$.googleFile = {
      ...stat$.googleFile,
      typeUseSheet: this.TYPE_USE.NEW,
      spreadSheetId: 0,
      spreadSheetTitle: '',
    };
    this.errors = {};
    let isValid = true;
    if (stat$.typeUseFile == this.TYPE_USE.NEW && !stat$.fileNew.fileName) {
      isValid = false;
      this.errors['fileNew.fileName'] = 'Tên bảng tính không được để trống';
    }
    if (stat$.typeUseFile == this.TYPE_USE.AVAILABLE && !this.getGoogleSheetsSpreadId(stat$.googleFile.spreadUrl)) {
      isValid = false;
      this.errors['spreadId'] = 'Link file Google Sheets không hợp lệ';
    }
    if (!stat$.googleFile.spreadSheetNewTitle) {
      isValid = false;
      this.errors['spreadSheetNewTitle'] = 'Tên trang tính không được để trống';
    }
    if (!isValid) {
      return;
    }
    this.progressState = {currentItem: 0, totalItems: 0, totalPages: 0, currentPage: 0};
    this.progressState.isExportSubmit = true;
    this.output$.next(stat$);
  }


  // Chọn file có sẵn | file tạo mới
  onChangeTypeUseFile($event: number) {
    this.state.typeUseFile = $event;
    this.state.googleFile.typeUseSheet = this.TYPE_USE.NEW;
  }


  override loadDepsDataGoogleSheet() {
    if (this.isLoadingGoogleAccount) return;

    this.isLoadingGoogleAccount = true;
    this.isLoadingTabGGSheet = false;
    this.googleAccountEmail = '';
    this.googleAccountLoadError = false;
    // Đọc lại API để lỗi tải không bị giữ trong cache setting dùng chung.
    this.conversationApiService.getUserSetting().pipe(
      takeUntil(this.appForm.destroyed),
      finalize(() => this.isLoadingGoogleAccount = false)
    ).subscribe({
      next: (res: any) => {
        this.googleAccountLoadError = res.code !== 1 || !res.data ||
          typeof res.data !== 'object' || Array.isArray(res.data);
        if (!this.googleAccountLoadError) {
          const email = res.data.googleAccount?.email;
          this.googleAccountEmail = typeof email === 'string' ? email.trim() : '';
        }
        this.isLoadingTabGGSheet = true;
        this.cdr.markForCheck();
      },
      error: () => {
        this.googleAccountLoadError = true;
        this.isLoadingTabGGSheet = true;
        this.cdr.markForCheck();
      }
    });
  }

  // Thay đổi link file GGS
  override onChangeSpreadGGUrl(spreadUrl: string) {
    // BE kiểm tra quyền truy cập file khi xuất; FE chỉ kiểm tra định dạng link.
    if (this.getGoogleSheetsSpreadId(spreadUrl)) {
      delete this.errors['spreadId'];
    } else {
      this.errors['spreadId'] = 'Link file Google Sheets không hợp lệ';
    }
  }


  readonly SETTING_GENERAL_URI = uriConsts.settings.SETTING_GENERAL;
}
